module.exports = __webpack_public_path__ + "img/Group 1673@2x.c589da58.png";